import * as Sentry from '@sentry/react'

export const openFeedbackDialog = async () => {
  const feedback = Sentry.getFeedback()

  if (!feedback) return

  const form = await feedback.createForm()
  form.appendToDom()
  form.open()
}
